// Standardized escalation type/reason lists for the Create Escalation modal
// (Member Outreach member page, L9 only). Reason options are dependent on
// the selected type; every type includes an "Other" reason that keeps the
// narrative description mandatory.
export const ESCALATION_TYPES = [
  "Clinical Concern",
  "Patient Safety Concern",
  "Medication Issue",
  "Scheduling/Access Issue",
  "Benefits/Coverage Issue",
  "Patient Complaint/Concern",
  "Other",
];

export const ESCALATION_REASONS_BY_TYPE = {
  "Benefits/Coverage Issue": [
    "Authorization Needed",
    "Benefit Clarification",
    "Coverage Denial",
    "Eligibility Question",
    "Other",
  ],
  "Clinical Concern": [
    "Care Plan Question",
    "Change in Condition",
    "Lab/Result Follow-Up",
    "Preventative Care Gap",
    "Symptoms Reported",
    "Therapeutic Gap",

    "Other",
  ],
  "Medication Issue": [
    "Adherence Concern",
    "Refill Needed",
    "Medication Question",
    "New prescription request",
    "Prior Authorization/Access Issue",
    "Provider denied request/suggestion",
    "Side Effect Reported",
    "Other",
  ],
  "Patient Safety Concern": [
    "Adverse Event",
    "Fall Risk",
    "Home Safety Concern",
    "Urgent Follow-Up Needed",
    "Other",
  ],
  "Patient Complaint/Concern": [
    "Care Experience Concern",
    "Communication Concern",
    "Service Concern",
    "Wait Time/Delay",
    "Other",
  ],
  "Scheduling/Access Issue": [
    "Access Barrier",
    "Appointment Needed",
    "Reschedule Request",
    "Other",
  ],
  // The top-level "Other" escalation type has no defined category list of
  // its own - it always resolves to "Other", which is what requires the
  // narrative description.
  Other: ["Other"],
};

export const ESCALATION_STATUSES = ["Open", "Resolved", "Canceled"];

// Once a version's status reaches one of these, its status can no longer be
// changed - the status control locks, though the rest of the latest
// version's fields (owner, description, etc.) stay editable.
export const TERMINAL_ESCALATION_STATUSES = ["Resolved", "Closed", "Canceled"];

// If the escalation was ALREADY in one of these statuses when the modal was
// opened, the Resolution text becomes view-only too - Closed escalations can
// still have their resolution revised, but Resolved/Canceled ones can't.
// Based on the status the record already had on open (not the live status
// state), so typing a resolution while changing status to Resolved in the
// same edit isn't blocked before it's even saved.
export const RESOLUTION_LOCKED_STATUSES = ["Resolved", "Canceled"];

// Optional - who the L9 user actually reached (or tried to reach) about this
// escalation. Shown below Owner; selecting one reveals Contact Status.
export const ESCALATION_CONTACT_TYPES = [
  "Patient",
  "Authorized Representative / Caregiver",
  "Provider / Prescriber",
  "Pharmacy",
  "Lucy Clinical Team",
  "Pharmacist",
  "Benefits / Coverage Team",
  "Client / Account Team",
  "Other",
];

// Selecting "Contact attempted" opens ContactAttemptModal to log the
// specifics of that attempt.
export const CONTACT_STATUSES = [
  "Contact attempted",
  "Contact completed",
  "Left voicemail",
  "Awaiting response",
  "Unable to reach",
];

export const CONTACT_METHODS = [
  "Phone",
  "Fax",
  "Email",
  "Portal",
  "Internal message/task",
  "Other",
];

// "Urgent" flags the escalation on the Escalations list.
export const ESCALATION_PRIORITIES = ["Low", "Medium", "High", "Urgent"];

// Required when status is set to Canceled.
export const CANCELLATION_REASONS = [
  "Created in error",
  "Duplicate escalation",
  "No longer needed",
  "Patient declined follow-up",
  "Other",
];
